<template>
  <div class="admin-sidebar dark-bg py-3 main mt-5">
    <h4 class>Admin Menu</h4>
    <div class="accordian" role="tablist">
      <ul class="nav flex-column">
        <li
          v-if="
            sidebarModules.some(
              ({ module_action }) => module_action === 'FUNDING'
            )
          "
        >
          <a class="nav-link" v-b-toggle.funding href="#funding #top">
            Funding
          </a>
          <b-collapse
            id="funding"
            accordion="my-accordion"
            role="tabpanel"
            :visible="isMenuMatched('funding')"
          >
            <router-link
              class="nav-link"
              :to="{
                name: 'FundingDashboard',
                params: { activeMenuItem: 'fundingDashboard' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('fundingDashboard'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) =>
                    sub_module_action === 'FundingDashboard'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Funding Dashboard
            </router-link>
          </b-collapse>
           <b-collapse
            id="funding"
            accordion="my-accordion"
            role="tabpanel"
            :visible="isMenuMatched('funding')"
          >
            <router-link
              class="nav-link"
              :to="{
                name: 'PaymentMethods',
                params: { activeMenuItem: 'paymentMethods' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('paymentMethods'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) =>
                    sub_module_action === 'PaymentMethods'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Payment Methods
            </router-link>
          </b-collapse>
        </li>
        <li
          v-if="
            sidebarModules.some(
              ({ module_action }) => module_action === 'DASHBOARD'
            )
          "
        >
          <a class="nav-link" v-b-toggle.dashboard href="#dashboard #top">
            Dashboards
          </a>
          <b-collapse
            id="dashboard"
            accordion="my-accordion"
            role="tabpanel"
            :visible="isMenuMatched('dashboard')"
          >
            <router-link
              class="nav-link"
              :to="{ name: 'P4P', params: { activeMenuItem: 'dashboardP4p' } }"
              @click.native="scrollToTop"
              v-bind:class="{ activeItem: isMenuItemMatched('dashboardP4p') }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) => sub_module_action === 'P4P'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              General
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'LoginAndOrdersReport',
                params: { activeMenuItem: 'dashboardLogin&Orders' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('dashboardLogin&Orders'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) =>
                    sub_module_action === 'LoginsOrders'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Logins & Orders
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'PointsRemaining',
                params: { activeMenuItem: 'dashboardPointsRemaining' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('dashboardPointsRemaining'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) =>
                    sub_module_action === 'PointsRemaining'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Points Remaining
            </router-link>
          </b-collapse>
        </li>
        <li
          v-if="
            sidebarModules.some(
              ({ module_action }) => module_action === 'ORDERS'
            )
          "
        >
          <a class="nav-link" v-b-toggle.orders href="#orders #top"> Orders </a>
          <b-collapse
            id="orders"
            accordion="my-accordion"
            role="tabpanel"
            :visible="isMenuMatched('orders')"
          >
            <router-link
              class="nav-link"
              :to="{
                name: 'OrderApproval',
                params: { activeMenuItem: 'ordersOrderApproval' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('ordersOrderApproval'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) =>
                    sub_module_action === 'OrderApproval'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Order Approval
            </router-link>
          </b-collapse>
        </li>
        <li
          v-if="
            sidebarModules.some(
              ({ module_action }) => module_action === 'REPORTS'
            )
          "
        >
          <a class="nav-link" v-b-toggle.reports href="#reports #top">
            Reports
          </a>
          <b-collapse
            id="reports"
            :visible="isMenuMatched('reports')"
            accordion="my-accordion"
            role="tabpanel"
          >
            <router-link
              class="nav-link"
              :to="{
                name: 'AdminLoginsAndOrdersReport',
                params: {
                  activeMenuItem: 'reportsLogins&OrdersReport',
                  activeMenu: 'reports',
                },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('reportsLogins&OrdersReport'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) =>
                    sub_module_action === 'LoginsOrdersReport'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Logins & Orders Report
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'AdminTransactionReport',
                params: {
                  activeMenuItem: 'reportsTransactionReport',
                  activeMenu: 'reports',
                },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('reportsTransactionReport'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) =>
                    sub_module_action === 'TransactionReport'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Transaction Report
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'TaxReportingDatabase',
                params: {
                  activeMenuItem: 'reportsTaxReportingDatabase',
                  activeMenu: 'reports',
                },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('reportsTaxReportingDatabase'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) =>
                    sub_module_action === 'TaxReportingDatabase'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Tax Reporting Database
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'GenerateExcelReport',
                params: {
                  activeMenuItem: 'reportsGenerateExcelReport',
                  activeMenu: 'reports',
                },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('reportsGenerateExcelReport'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) =>
                    sub_module_action === 'GenerateExcelReport'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Generate Excel Report
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'GenerateTaxationReport',
                params: {
                  activeMenuItem: 'reportsGenerateTaxationReport',
                  activeMenu: 'reports',
                },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('reportsGenerateTaxationReport'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) =>
                    sub_module_action === 'GenerateLibertyTaxationReport'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Generate Liberty Taxation Report
            </router-link>
          </b-collapse>
        </li>
        <li
          v-if="
            sidebarModules.some(
              ({ module_action }) => module_action === 'USERS'
            )
          "
        >
          <a class="nav-link" v-b-toggle.users href="#users #top"> Users </a>
          <b-collapse
            id="users"
            :visible="isMenuMatched('users')"
            accordion="my-accordion"
            role="tabpanel"
          >
            <router-link
              class="nav-link"
              :to="{
                name: 'AdminUserManager',
                params: {
                  activeMenuItem: 'usersUserManager',
                  activeMenu: 'users',
                },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('usersUserManager'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) => sub_module_action === 'UserManager'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              User Manager
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'AdminUsersTotalPoints',
                params: {
                  activeMenuItem: 'usersTotalPoints',
                  activeMenu: 'users',
                },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('usersTotalPoints'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) => sub_module_action === 'TotalPoints'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Total Points
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'AdminBatchUserUploadTool',
                params: {
                  activeMenuItem: 'usersBatchUserUploadTool',
                  activeMenu: 'users',
                },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('usersBatchUserUploadTool'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) =>
                    sub_module_action === 'BatchUserUploadTool'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Batch User-Upload Tool
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'AdminBatchUserCreateTool',
                params: {
                  activeMenuItem: 'usersBatchUserCreateTool',
                  activeMenu: 'users',
                },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('usersBatchUserCreateTool'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) =>
                    sub_module_action === 'BatchUserCreateTool'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Batch User-Create Tool
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'AdminBatchPointUploadTool',
                params: {
                  activeMenuItem: 'usersBatchPointUploadTool',
                  activeMenu: 'users',
                },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('usersBatchPointUploadTool'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) =>
                    sub_module_action === 'BatchPointUploadTool'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Batch Point-Upload Tool
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'AdminSendEmailToUser',
                params: {
                  activeMenuItem: 'usersSendEmailToUsers',
                  activeMenu: 'users',
                },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('usersSendEmailToUsers'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) =>
                    sub_module_action === 'SendEmailtoUsers'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Send Email to Users
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'AdminAddPointsSelectPrograms',
                params: {
                  activeMenuItem: 'usersAddPoints',
                  activeMenu: 'users',
                },
              }"
              @click.native="scrollToTop"
              v-bind:class="{ activeItem: isMenuItemMatched('usersAddPoints') }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) => sub_module_action === 'AddPoints'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Add Points
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'AdminPointPrograms',
                params: {
                  activeMenuItem: 'usersPointPrograms',
                  activeMenu: 'users',
                },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('usersPointPrograms'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) =>
                    sub_module_action === 'PointPrograms'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Point Programs
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'UsersUpdate',
                params: {
                  activeMenuItem: 'usersUpdate',
                  activeMenu: 'users',
                },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('usersUpdate'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) =>
                    sub_module_action === 'GenerateLibertyTaxationReport'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Users Update
            </router-link>
          </b-collapse>
        </li>
        <li
          v-if="
            sidebarModules.some(
              ({ module_action }) => module_action === 'COMMUNICATION'
            )
          "
        >
          <a
            class="nav-link"
            v-b-toggle.communication
            href="#communication #top"
          >
            Communication
          </a>
          <b-collapse
            id="communication"
            accordion="my-accordion"
            role="tabpanel"
            :visible="isMenuMatched('communication')"
          >
            <router-link
              class="nav-link"
              :to="{
                name: 'ClientBlogs',
                params: { activeMenuItem: 'communicationClientBlogs' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('communicationClientBlogs'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) => sub_module_action === 'ClientBlogs'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Client Blogs
            </router-link>
          </b-collapse>
        </li>
        <li
          v-if="
            sidebarModules.some(
              ({ module_action }) => module_action === 'SETTINGS'
            )
          "
        >
          <a class="nav-link" v-b-toggle.settings href="#settings #top">
            Settings
          </a>
          <b-collapse
            id="settings"
            accordion="my-accordion"
            role="tabpanel"
            :visible="isMenuMatched('settings')"
          >
            <router-link
              class="nav-link"
              :to="{
                name: 'AdminSettingsRoleAndPermissions',
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('rolesAndPermissions'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) =>
                    sub_module_action === 'RolesandPermissions'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Roles and Permissions
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'AdminSettingsModules',
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('modules'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) => sub_module_action === 'Modules'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Modules
            </router-link>
          </b-collapse>
        </li>
        <li
          v-if="
            sidebarModules.some(
              ({ module_action }) => module_action === '1TIMEPAYMENT'
            )
          "
        >
          <a class="nav-link" v-b-toggle.1TimePayment href="#1TimePayment #top">
            One Time Payment
          </a>
          <b-collapse
            id="1TimePayment"
            accordion="my-accordion"
            role="tabpanel"
            :visible="isMenuMatched('1TimePayment')"
          >
            <router-link
              class="nav-link"
              :to="{
                name: 'Payment',
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('prefunding'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) => sub_module_action === 'Prefunding'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Prefunding
            </router-link>
          </b-collapse>
        </li>
        <li
          v-if="
            sidebarModules.some(
              ({ module_action }) => module_action === 'RECOGNITION'
            )
          "
        >
          <a class="nav-link" v-b-toggle.recognition href="#recognition #top">
            Recognition
          </a>
          <b-collapse
            id="recognition"
            accordion="my-accordion"
            role="tabpanel"
            :visible="isMenuMatched('recognition')"
          >
            <router-link
              class="nav-link"
              :to="{
                name: 'RecognitionChallenges',
                params: { activeMenuItem: 'recognitionChallenges' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('recognitionChallenges'),
              }"
              v-if="
                sidebarSubModules.some(
                  ({ sub_module_action }) =>
                    sub_module_action === 'ChallengesConfiguration'
                )
              "
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Recognition Configuration
            </router-link>
          </b-collapse>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "AdminSidebar",

  data() {
    return {
      ActiveItem: "",
    };
  },

  computed: {
    ...mapGetters({
      sidebarModules: "getSidebarModules",
      sidebarSubModules: "getSidebarSubModules",
    }),
  },

  methods: {
    isMenuItemMatched(menuItem) {
      return this.$store.getters["adminSidebar/getActiveItem"] === menuItem
        ? true
        : false;
    },
    isMenuMatched(menu) {
      return this.$store.getters["adminSidebar/getActiveMenu"] === menu
        ? true
        : false;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },

    fetchModules() {
      this.$store.dispatch("fetchSidebarModules", {
        ishradmin: true,
      });
    },
  },

  created() {
    if (this.sidebarSubModules.length === 0) {
      this.fetchModules();
    }
  },
};
</script>

<style lang="scss" scoped>
.admin-sidebar {
  background-color: $gray-900;
  color: $white !important;
  min-height: 90vh;
  padding: 24px 0px 24px 0px;
  font-weight: 700;
  h4 {
    color: $white !important;
    padding: 12px 32px;
    &::after {
      display: none;
    }
  }
  a {
    padding: 18px 36px;
    color: $white;
    &:hover {
      background-color: transparentize($primary, 0.7%);
    }
  }
}
.main {
  overflow: auto;
  padding-bottom: 1px;
}
.main::-webkit-scrollbar {
  display: none;
}

.activeItem {
  background-color: $primary;
}
</style>
